import axios from 'axios';
import config from './config';

const BASE_URL = config.baseApi;

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const getAuthToken = () => {
  const cookieMatch =
    document.cookie.match(/(?:^|; )buyer_token=([^;]*)/) ||
    document.cookie.match(/(?:^|; )public_private_token=([^;]*)/);
  const cookieToken = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
  return (
    cookieToken ||
    localStorage.getItem('buyer_token') ||
    sessionStorage.getItem('buyer_token') ||
    localStorage.getItem('public_private_token')
  );
};

const requestHandler = (request: any) => {
  const token = getAuthToken();
  if (token) {
    const cleanToken = token.replace(/^"|"$/g, '');
    request.headers.Authorization = `Bearer ${cleanToken}`;
  }
  return request;
};

const responseHandler = (response: any) => {
  return response;
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => Promise.reject(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => {
    return Promise.reject(error);
  }
);

export default customAxios;
